import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  StSiteMasterDetailColumn,
  StSiteMasterDetailGrid,
  StSiteMasterDetailWrapper,
  StSiteMasterSidebarColumn,
} from 'components/SiteMaster/SiteMaster.styles';

const SiteDetail = (props: ComponentProps): JSX.Element => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <StSiteMasterDetailGrid id="site-details-container">
      {isDesktop ? (
        <StSiteMasterDetailWrapper id="site-details-wrapper">
          <Box id="site-details-left">
            <StSiteMasterDetailColumn>
              <Placeholder name="jss-site-left" rendering={props.rendering} />
            </StSiteMasterDetailColumn>
          </Box>

          <Box id="site-details-right">
            <StSiteMasterSidebarColumn>
              <Placeholder name="jss-site-right" rendering={props.rendering} />
            </StSiteMasterSidebarColumn>
          </Box>
        </StSiteMasterDetailWrapper>
      ) : (
        <StSiteMasterDetailColumn>
          <Placeholder name="jss-site-left" rendering={props.rendering} id="site-details-sm-left" />

          <Placeholder
            name="jss-site-right"
            rendering={props.rendering}
            id="site-details-sm-right"
          />
        </StSiteMasterDetailColumn>
      )}
    </StSiteMasterDetailGrid>
  );
};

export default SiteDetail;
